document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded',()=>{
  const toggle=document.querySelector('[data-menu-toggle]');
  const nav=document.querySelector('[data-mobile-nav]');
  if(toggle&&nav) toggle.addEventListener('click',()=>nav.classList.toggle('open'));
  const observer=new IntersectionObserver(entries=>entries.forEach(e=>{if(e.isIntersecting)e.target.classList.add('is-visible')}),{threshold:.12});
  document.querySelectorAll('.reveal').forEach(el=>observer.observe(el));
  document.querySelectorAll('[data-variant-select]').forEach(select=>select.addEventListener('change',e=>{
    const option=e.target.options[e.target.selectedIndex];
    const price=document.querySelector('[data-product-price]');
    if(price&&option.dataset.price) price.textContent=option.dataset.price;
  }));
});
